module.exports = __webpack_public_path__ + "static/img/mKyuJing.eaf9cbed.png";